export class NotAuthenticatedError extends Error {
  status: number;
  constructor(message = 'Unauthenticated') {
    super(message);
    this.name = 'Not Authenticated';
    this.status = 401;
  }
}
